import React from 'react';
import DeleteNodeButton from '../DeleteNodeButton/DeleteNodeButton';

interface NodeHeaderProps {
  nodeTitle: string;
  onNodeDelete?: () => Promise<void>;
  deleteButtonRef?: React.RefObject<HTMLButtonElement>;
  isLocked?: boolean;
}

function NodeHeader({
  nodeTitle,
  onNodeDelete,
  deleteButtonRef,
  isLocked = false
}: Readonly<NodeHeaderProps>): React.ReactElement | null {
  return (
    <div className='flex justify-between items-start mb-2 -mt-1'>
      <div className='text-sm pt-1'>{nodeTitle}</div>
      {onNodeDelete && deleteButtonRef && !isLocked && (
        <DeleteNodeButton
          onDelete={onNodeDelete}
          deleteButtonRef={deleteButtonRef}
        />
      )}
    </div>
  );
}

export default NodeHeader;
